import React from "react";
import { Button } from "carbon-components-react";
import { useNavigate } from "react-router-dom";

const DataOperationButton = ({ operations }) => {

  const navigate = useNavigate();

  return (
    <>
      {operations.map((o) => (
        <Button key={o.id}
          kind="ghost"
          onClick={() => navigate(o.url)}
          renderIcon={o.icon} iconDescription={o.title} title={o.title}
        >
        </Button>
      ))}

    </>
  );
};

DataOperationButton.defaultProps = {
  operations: [],
};

export default DataOperationButton;
